/**
 * Oturum token'ı ve axios yetki başlığı — tek noktadan.
 *
 * Token localStorage'da **`auth_token`** anahtarıyla tutulur (AuthContext bu adı
 * yazar). Bileşenler bugüne kadar bu ifadeyi tek tek kopyalıyordu; bir yerde
 * yanlış anahtar ('token') kullanılınca istek Authorization başlığı olmadan
 * gidiyor ve backend "Not authenticated" dönüyordu. Yeni kod bu yardımcıyı
 * kullanmalı.
 */
export const TOKEN_KEY = 'auth_token';

/** Ham token; yoksa null. */
export const getToken = () => localStorage.getItem(TOKEN_KEY) || null;

/**
 * axios istekleri için yetki başlığı.
 * Kullanım: axios.get(url, authHeaders())
 */
export const authHeaders = () => {
  const token = getToken();
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

export default { TOKEN_KEY, getToken, authHeaders };
